import { render, staticRenderFns } from "./Mepandes.vue?vue&type=template&id=3f3a0e01&"
import script from "./Mepandes.vue?vue&type=script&lang=js&"
export * from "./Mepandes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports